import * as R from "ramda";
import { DATAQUERY_DIMENSIONS_SEPARATOR, DATAQUERY_VALUES_SEPARATOR } from "./constants/url.mjs";
import { isFrequency } from "./utils.mjs";
const getJoinValuesIds = ({ current, valIds }) => (dimension) => {
  if (R.isEmpty(valIds)) return "";
  const dimensionIndexedByValueId = R.pipe(
    R.propOr([], "values"),
    R.indexBy(R.prop("id"))
  )(dimension);
  const getSanitizeValidIds = R.filter(
    R.flip(R.has)(dimensionIndexedByValueId)
  );
  return R.pipe(
    R.when(R.pipe(R.isNil, R.not), R.split(DATAQUERY_VALUES_SEPARATOR)),
    R.reject(R.isEmpty),
    getSanitizeValidIds,
    R.symmetricDifference(getSanitizeValidIds(valIds)),
    R.join(DATAQUERY_VALUES_SEPARATOR)
  )(current);
};
const updateDataquery = (dimensions, dataquery, valIdsIndexByDimId) => {
  const splitDataquery = R.split(DATAQUERY_DIMENSIONS_SEPARATOR, dataquery);
  return R.pipe(
    R.addIndex(R.map)((dim, index) => {
      const current = R.nth(index, splitDataquery);
      const dimId = R.prop("id", dim);
      const valIds = R.prop(dimId)(valIdsIndexByDimId);
      if (isFrequency(dim)) {
        if (R.either(R.isNil, R.isEmpty)(valIds)) return current;
        return R.ifElse(
          R.pipe(R.prop("values"), R.find(R.propEq(R.head(valIds), "id"))),
          // frequency valIds take only the first one
          R.always(R.head(valIds)),
          // for frequency, if valid new value, replace current
          R.always(current)
          // else keep current, not erased, no matter what
        )(dim);
      }
      if (R.either(R.isNil, R.isEmpty)(valIdsIndexByDimId)) return "";
      return R.cond([
        [
          R.always(R.has(dimId, valIdsIndexByDimId)),
          // matching dimId
          getJoinValuesIds({ current, valIds })
        ],
        [R.T, R.always(current)]
        // keep current
      ])(dim);
    }),
    R.join(DATAQUERY_DIMENSIONS_SEPARATOR)
  )(dimensions);
};
const updateDataquery$1 = R.curry(updateDataquery);
export {
  updateDataquery$1 as default
};
